import React from "react";
import PropTypes from "prop-types";

import NavButton from "./NavButton.js";
import C from "../../constants";
import { canAdvance, currentQuestion } from "../../state/questionStates.js";
import strings from "../../resources/strings";

export const NextButton = (props, { store }) => {
    let state = store.getState();
    if (
        state &&
        (!state.clientRequest ||
            (state.clientRequest &&
                (state.clientRequest.state === "NEW" ||
                state.clientRequest.state === "STARTED" ||
                state.clientRequest.state === "STICKY" ||
                state.clientRequest.state === "INTERRUPTED" ||
                state.clientRequest.state === "ABANDONED")))
    
    ) {
        let question = currentQuestion(state);

        if (question) {
            let defaultQuestionOrder = state.questionSet.questionSet.defaultQuestionOrder;

            let isForm = question.questionType === "form";
            let isLastQuestion = (defaultQuestionOrder.indexOf(question.questionId) === (defaultQuestionOrder.length - 1));
            let isAdditionalQuestion = question.questionType === "camera" && question.questionSpecifier === "additionalQuestion";

            if (isLastQuestion || isAdditionalQuestion) {
                return null;
            }

            if (isForm) {
                return (
                    <NavButton
                        onClick={() => store.dispatch({ type: C.NEXT_QUESTION })}
                        question={question}
                        text={strings.getString("nextButtonText")}
                        disabled={!canAdvance(store.getState())}
                        id="nextButton"
                    />
                );
            }
        }
    }
    return null;
};

NextButton.contextTypes = {
    store: PropTypes.object
};

export default NextButton;
